module.exports = {
  // 通用
  lang: {
    zh: '简体中文',
    'zh-TW': '繁體中文',
    en: 'English'
  },
  
  // 顶部导航
  nav: {
    aboutUs: '关于我们',
    society: '社会责任',
    news: '新闻动态',
    investor: '投资者关系',
    joinUs: '加入我们'
  },
  
  // 投资者关系
  investor: {
    banner: {
      ch: '投资者关系',
      en: 'Investor Relations'
    },
    tabs: {
      report: '公告及新闻稿',
      finReport: '财务报告',
      court: '董事会',
      company: '公司信息',
      telMeeting: '投资者活动',
      analyst: '分析师',
      businessFile: '企业管治文件',
      contactUs: '联系我们',
      faq: '常见问题',
      investorEn: 'Investor Relations'
    },
    // 公告及新闻稿
    report: {
      notice: '公司通讯可于本公司的网站（<a href="www.kingsoft.com" target="_blank">www.kingsoft.com</a>）及香港联合交易所有限公司网站（<a href="www.hkexnews.hk" target="_blank">www.hkexnews.hk</a>）查阅。可供采取行动的公司通讯* 将通过登记股东提供的电子邮件地址或以印刷版本个别发送。<br><br>倘阁下需要公司通讯的印刷本，可以通过发送邮件至股份过户处香港中央证券登记有限公司的邮箱<a href="mailto:kingsoft.ecom@computershare.com.hk">kingsoft.ecom@computershare.com.hk</a>提出有关要求。<br><br>倘阁下需要选择/更换接受公司通讯的方式，及/或提供/更改电子联络资料，请联系股份过户处香港中央证券登记有限公司（适用于已登记股东）或阁下持有股份的银行、经纪、托管商、代理人或香港中央结算（代理人）有限公司（适用于非登记股东）。',
      noticeFoot: '* 可供采取行动的公司通讯指任何涉及要求本公司的证券持有人指示其拟如何行使其有关证券持有人的权利或作出选择的公司通讯。',
      title: '公告及新闻稿',
      tabs: {
        announcement: '公告',
        news: '新闻稿'
      },
      yearPlaceholder: '选择年份',
      noData: '暂无数据'
    },
    // 财务报告
    finReport: {
      title: '财务报告',
      year: '年度',
      interim: '中期报告',
      annual: '年度报告',
      quarterly: '季度报告'
    },
    // 董事会
    court: {
      title: '董事会',
      chairman: '董事会主席',
      member: '董事会成员',
      independent: '独立非执行董事',
      directors: [
        {
          name: '雷军',
          title: '董事会主席及非执行董事',
          intro: '雷军，56岁，本公司非执行董事、董事会主席、提名委员会主席、薪酬委员会成员及联合创办人。雷先生由一九九二年起受聘于本公司，于发展及扩展本集团的业务运营方面承担重要角色。彼自一九九八年起出任本集团首席执行官，在其领导下本集团进一步从应用软件业务扩展至实用软件、互联网安全软件及网络游戏。彼亦在将本集团由一间传统软件公司转变为一间广泛应用互联网按客户需求提供服务的软件公司方面承担重要角色。雷先生于二零零七年十二月辞去首席执行官、首席技术官和总裁的职位，于二零零八年八月由执行董事调任为非执行董事。雷先生在二零一一年七月五日被委任为本公司董事会主席。雷先生亦为本公司若干附属公司的董事。',
          detail: '雷先生于二零一零年与其他合伙人联合创立小米公司（二零一八年七月于联交所上市，股票代码：1810），目前担任执行董事、董事长、首席执行官及薪酬委员会委员。自二零一一年十二月起，雷先生担任金山办公（上交所科创板：688111）董事。雷先生自二零一五年四月至二零二六年三月担任金山云（一家于联交所上市的公司，股票代码：03896和纳斯达克：KC）董事长。\n\n雷先生于一九九一年七月于武汉大学计算机科学系毕业，获得理学学士学位。彼于二零零三年起担任武汉大学董事会成员。\n\n雷先生也是中国活跃的天使投资人。'
        },
        {
          name: '邹涛',
          title: '执行董事及首席执行官',
          intro: '邹涛，50岁，现任本公司执行董事，首席执行官（"首席执行官"）及环境、社会及管治委员会成员。邹先生目前担任西山居的董事及代理首席执行官、金山办公（上交所科创板：688111）的董事长和金山云（一家于联交所上市的公司，股票代码：03896和纳斯达克：KC）的董事长及代理首席执行官。邹先生自二零一六年十二月一日至二零二零年四月二日担任迅雷有限公司（纳斯达克：XNET）的董事，自二零一六年十二月一日至二零二零年十二月十四日担任世纪互联集团（纳斯达克：VNET）的董事，以及自二零一六年十二月一日至二零二四年六月三十日担任猎豹移动（纽交所：CMCM）的董事。邹先生一九九七年毕业于南开大学。邹先生于一九九八年加盟本公司，并负责开发本集团的金山词霸产品。邹先生自二零零四年起负责本集团的娱乐软件业务，于二零一八年一月前担任西山居之首席执行官。自二零二二年起，邹先生担任金山云代理首席执行官。自二零二五年十二月起，邹先生担任西山居代理首席执行官。自二零二六年三月起，邹先生担任金山云董事长。',
          detail: '邹先生于二零零七年十二月成为本公司的高级副总裁，自二零零九年八月起担任本公司执行董事，自二零一六年十二月起担任本公司首席执行官。\n\n邹先生亦为本公司若干附属公司的董事。'
        },
        {
          name: '求伯君',
          title: '非执行董事',
          intro: '求伯君，61岁，二零一一年十月二十四日起由本公司执行董事调任为非执行董事。求先生目前担任金山办公（上交所科创板：688111）的董事。求先生由一九八八年起受聘于本公司。彼于一九八四年在中国国防科技大学毕业，并取得信息管理系统学士学位。于一九八四年至一九八七年间，求先生于多间中国公司出任软件开发人员。',
          detail: '求先生于一九八八年创办金山软件及专责开发WPS 1.0。求先生于二零零零年获中国中央电视台选为十大年度经济人物，于二零零一年获选为年度财经界风云人物，及于二零零五年一月的中国游戏产业年会就职典礼上获选为中国游戏产业十位最具影响力领袖之一，于二零零九年十二月的中国游戏行业年会上获选为中国游戏行业二零零九年度优秀企业家。求先生于二零零七年十二月获委任为本公司代理首席执行官，求先生自二零零八年五月担任本公司首席执行官，并于二零一一年十月二十四日辞任。二零一一年七月五日前，求先生担任本公司董事会主席。\n\n求先生亦为本公司若干附属公司的董事。'
        }
      ]
    },
    // 公司信息
    company: {
      title: '公司概览',
      hkAddress: {
        title: '香港主要经营地址',
        addressLabel: '地址：',
        address1: '香港九龙尖沙咀海港城港威大厦',
        address2: '第5座32楼3208室',
        phoneLabel: '电话：',
        phone1: '(852) 98303138 (手机)',
        phone2: '(852) 24050088 (座机)'
      },
      market: {
        title: '市场信息',
        exchange: '交易所: 港交所',
        listingDate: '上市日期： 二零零七年十月九日',
        stockCode: '股票代码：3888'
      },
      auditor: {
        title: '核数师',
        name: '安永会计师事务所（注册公众利益实体核数师）',
        address1: '香港鲗鱼涌',
        address2: '英皇道979号',
        address3: '太古坊一座27楼'
      },
      audit: {
        title: '审核委员会',
        members: ['武文洁女士（主席）', '陈作涛先生', '杜博先生']
      },
      remuneration: {
        title: '薪酬委员会',
        members: ['陈作涛先生（主席）', '雷军先生', '武文洁女士', '杜博先生']
      },
      nomination: {
        title: '提名委员会',
        members: ['雷军先生（主席）', '姚磊文先生', '武文洁女士', '陈作涛先生', '杜博先生']
      },
      esg: {
        title: '环境、社会及管治委员会',
        members: ['陈作涛先生（主席）', '邹涛先生', '武文洁女士', '杜博先生']
      }
    },
    // 投资者活动
    telMeeting: {
      title: '投资者活动',
      webcast: '网络直播',
      date: '日期',
      time: '时间',
      download: '下载',
      playback: '回放'
    },
    // 分析师
    analyst: {
      title: '分析师',
      name: '姓名',
      institution: '机构',
      contact: '联系方式'
    },
    // 企业管治文件
    businessFile: {
      title: '企业管治文件',
      fileName: '文件名称',
      date: '发布日期',
      download: '下载'
    },
    // 联系我们
    contactUs: {
      title: '联系我们',
      name: '姓名',
      phone: '联系方式',
      email: '电子邮箱',
      message: '留言内容',
      submit: '提交',
      followUs: '关注我们'
    },
    // 常见问题
    faq: {
      title: '常见问题',
      question: '问题',
      answer: '答案',
      questions: [
        {
          q: '金山软件有限公司位于哪里？',
          a: '金山软件有限公司总部位于香港，并且在北京、珠海、武汉、成都、大连及香港等多地分设研发中心。\n\n公司位于香港的地址为：\n香港九龙尖沙咀海港城港威大厦第5座32楼3208室\n电话: ( 852 ) 98303138 ( 手机 )\n( 852 ) 24050088 ( 座机 )\n\n公司位于北京的地址为：\n北京市海淀区西二旗中路33号 小米科技园D栋\n邮编: 100085\n电话: 8610 82335515\n传真: 8610 82325655'
        },
        {
          q: '金山软件有限公司在哪里上市？',
          a: '公司在香港联交所上市，股票代码3888。'
        },
        {
          q: '金山软件有限公司首次公开上市是什么时间？',
          a: '2007年10月9日。'
        },
        {
          q: '金山软件有限公司每个财年截止何时？',
          a: '截至每年十二月月末。'
        },
        {
          q: '金山软件有限公司的独立审计师是谁？',
          a: '香港安永会计师事务所。'
        },
        {
          q: '金山软件有限公司的香港合规法律顾问是谁？',
          a: '贝克•麦坚时律师事务所。'
        }
      ]
    }
  },

  // 社会责任
  society: {
    banner: {
      ch: '技术立业 持续发展',
      en: 'Sustainable Development Of Technology'
    },
    tabs: {
      report: '环境、社会及管治报告',
      esg: 'ESG评级与奖项',
      foundation: '公益基金会'
    },
    report: {
      title: '环境、社会及管治报告',
      yearlyTitle: '历年报告',
      chairman: {
        title: '主席致辞',
        para1: '2025年，人工智能技术迭代与规模化应用显著提速，持续重塑产业生态格局，数字经济与实体经济融合迈入全方位、深层次的新阶段，行业发展在变革中孕育新机、在调整中实现升级。三十七年初心不改，金山软件始终坚守"技术立业"的核心方向，以创新破局，持续加大研发投入，在办公软件、游戏产品与服务等领域稳健深耕。我们持续将ESG理念深度融入企业发展战略和经营管理、业务创新与价值创造的每一环节，推动公司实现长期价值。面对AI规模化应用的浪潮，我们秉持"科技向善、共生共赢"的理念，从合规治理到服务提质，从低碳践行到公益赋能，从人才培育到生态共建，全方位深化ESG实践，以实际行动践行科技企业的使命与担当，助力行业高质量发展。',
        para2: '初心如磐，虽远不怠。展望未来，金山软件将继续以技术立业为基，以ESG理念为舵，将责任担当融入每一次创新、每一项服务。我们将以更加开放的姿态，与所有利益相关方携手，为行业的高质量发展和社会的可持续未来贡献坚实的"金山力量"。',
        name: '雷军',
        position: '董事会主席'
      }
    },
    esg: {
      title: 'ESG评级与奖项',
      ratings: [
        { label: 'MSCI', scores: ['AA（2025）', 'AA（2024）', 'BBB（2023）'] },
        { label: 'S&P ESG Score', scores: ['63（2025）', '54（2024）', '43（2023）'] }
      ],
      awards: [
        { file: 'Member of the S&P Global Sustainability Yearbook 2026.pdf', name: '入选标普全球《可持续发展年鉴2026（全球版）》（The Sustainability Yearbook 2026）' },
        { file: 'Global-CSA-Score-Chinese-Corporate.pdf', name: '荣获"中国企业标普全球CSA评分最佳1%"表彰' },
        { file: '标普全球《可持续发展年鉴2025（全球版）》.pdf', name: '入选标普全球《可持续发展年鉴2025（全球版）》（The Sustainability Yearbook 2025）' },
        { file: '标普全球"行业最佳进步企业"表彰.pdf', name: '荣获标普全球"行业最佳进步企业"表彰' },
        { file: '入选标普《可持续发展年鉴（中国版）2024》.pdf', name: '入选标普全球《可持续发展年鉴（中国版）2024》' },
        { file: '金山软件-上市公司可持续优秀实践案例证书.pdf', name: '入选中国上市公司协会2025年上市公司可持续发展优秀实践案例' },
        { file: '入选中国上市公司协会2024年上市公司可持续发展优秀实践案例.pdf', name: '入选中国上市公司协会2024年上市公司可持续发展优秀实践案例' },
        { file: '金山软件-上市公司ESG优秀实践案例证书.pdf', name: '入选中国上市公司协会2023年上市公司ESG优秀实践案例' }
      ]
    }
  },

  // 页脚
  footer: {
    copyright: '© 2024 金山软件有限公司',
    privacy: '隐私政策',
    terms: '使用条款',
    contact: '联系我们',
    followUs: '关注我们',
    backToTop: '回到顶部'
  }
}
